import React from "react";
import { Radar } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PlcspEmptyState({
    openOnly,
    totalIncludingClosed,
    onShowClosed,
}) {
    return (
        <div className="bg-white border border-ink-100 rounded-2xl p-12 text-center shadow-pop">
            <Radar
                className="mx-auto text-ink-300 mb-3"
                size={36}
                strokeWidth={1.5}
            />
            <div className="font-display text-xl font-black mb-1">Sin resultados</div>
            {openOnly && totalIncludingClosed > 0 ? (
                <>
                    <div className="text-sm text-ink-500 font-medium mb-4">
                        Hay{" "}
                        <span className="font-bold text-ink-950">
                            {totalIncludingClosed.toLocaleString("es-ES")}
                        </span>{" "}
                        licitacion{totalIncludingClosed === 1 ? "" : "es"} que coinciden con
                        tu búsqueda, pero todas están en evaluación, resueltas o con el plazo
                        cerrado.
                    </div>
                    <Button
                        onClick={onShowClosed}
                        className="rounded-full bg-brand-600 hover:bg-brand-700 h-10 px-5 font-bold shadow-pop"
                        data-testid="plcsp-show-closed-btn"
                    >
                        Ver {totalIncludingClosed.toLocaleString("es-ES")} cerradas / en
                        evaluación
                    </Button>
                </>
            ) : (
                <div className="text-sm text-ink-500 font-medium">
                    Prueba con otra palabra clave o quita filtros.
                </div>
            )}
        </div>
    );
}
